// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AppContent from "./AppContent";
import { SnackbarProvider } from "./context/SnackbarContext";
import { HomeFabProvider } from "./context/HomeFabContext";
import NoInternet from "./components/common/modals/NoInternet";
import useOnlineStatus from './hooks/useOnlineStatus';

function App() {
  const isOnline = useOnlineStatus();
  const [noInternetDialogOpen, setNoInternetDialogOpen] = useState(false);
  useEffect(() => {
    if (!isOnline)
    {
      setNoInternetDialogOpen(true);
    }
  }, [isOnline]);
  return (
    <>
    <SnackbarProvider>
        <AuthProvider>
          <HomeFabProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
          </HomeFabProvider>
        </AuthProvider>
    </SnackbarProvider>
    <NoInternet 
      open={noInternetDialogOpen}
      onClose={() => setNoInternetDialogOpen(false)}
      isOnline={isOnline}
    />
    </>
  );
}

export default App;
